import React from "react";
import {message, Modal, Table} from "antd";
import {chatService} from "../../../services/chatService";
import {columns} from "./chats/ChatsTableColumns";
import {showConfirm} from "../../../components/File/AvailableFiles";
import {Spinner} from "../../../components/DesignSystem/Spinner/Spinner";


export const SelectChatModal = ({onClose}) => {

    const [chats, setChats] = React.useState(undefined);
    const [loading, setLoading] = React.useState(false);

    const loadChats = () => {

        chatService.getChats().then((response) => {
            setLoading(true);
            setChats(response.data);
        }).catch((error) => {
            console.error("Error fetching conversations:", error);
            setChats(undefined);
        }).finally(() => {
            setLoading(false);
        });

    }

    const handleDeleteConversation = (key) => {
        setLoading(true);
        chatService.deleteChat(key).then(() => {
            message.success("Conversation deleted successfully");
            loadChats();
        }).catch((error) => {
            message.error("Error deleting conversation");
            setLoading(false);
        }).finally(() => {
        });
    }

    const handleMenuSelect = (record) => {
        showConfirm("Confirmation", `Do you really want to delete the conversation <strong>${record.name}?</strong>`, () => {
            handleDeleteConversation(record.id);
        });
    }

    React.useEffect(() => {
        loadChats();
    }, []);

    return <Modal open={true} onCancel={onClose} onOk={onClose} width={1000} destroyOnClose={true}>
        <Spinner loading={loading} tip={"Loading chats..."}>
            <div style={{padding: '30px'}}>
                <Table dataSource={chats} rowKey="key" showHeader={false} columns={columns(handleMenuSelect)} pagination={false} size="small"
                       scroll={{y: '60vh', x: 'max-content'}}/>
            </div>
        </Spinner>

    </Modal>


}